export class LpDetailsModel {

    public id: number;
    public shortName: string;
    public name: string;
    public isGov: number;
    public employeesNumber: number;
    public charterCapital: string;
    public charterCapitalCurrency: string;
    public branchOffices: string;
    public orgFormId: number;
    public orgStructure: string;
    public note: string;
    public noteUpdatedBy: string;
    public withVat: boolean

    constructor(obj?: any) {
        this.id                     = obj && obj.id                     || null;
        this.shortName              = obj && obj.shortName              || '';
        this.name                   = obj && obj.name                   || '';
        this.isGov                  = obj && obj.isGov                  || null;
        this.employeesNumber        = obj && obj.employeesNumber        || null;
        this.charterCapital         = obj && obj.charterCapital         || '';
        this.charterCapitalCurrency = obj && obj.charterCapitalCurrency || '';
        this.branchOffices          = obj && obj.branchOffices          || '';
        this.orgFormId              = obj && obj.orgFormId              || null;
        this.orgStructure           = obj && obj.orgStructure           || '';
        this.note                   = obj && obj.note                   || '';
        this.noteUpdatedBy          = obj && obj.noteUpdatedBy          || '';
        this.withVat                = obj && obj.withVat !== 0          || false;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/lp-details.model.ts